import { render, staticRenderFns } from "./CouponBtn.vue?vue&type=template&id=01628120&scoped=true"
import script from "./CouponBtn.vue?vue&type=script&lang=ts"
export * from "./CouponBtn.vue?vue&type=script&lang=ts"
import style0 from "./CouponBtn.vue?vue&type=style&index=0&id=01628120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01628120",
  null
  
)

export default component.exports